import * as React from "react";
import { connect } from "react-redux";
import Component from "../../AbstractComponent";
import Constants from "../../../Action/Constants";
// import TypeContainer from "../../../Entity/Entities/ContactForContract/Type/TypeContainer";
import Time from "../../../Time/Time";
// import { TypeInterface } from "../../../Entity/Entities/ContactForContract/Type/TypeInterface";
import { Attachment } from "../../Partials/Attachment/Attachment";
import { PromptDialog } from "../../Partials/Dialog/PromptDialog";
import { LeavePromptDialog } from "../../Partials/Dialog/LeavePromptDialog";
import { UnitInterface } from "../../../Entity/Entities/Unit/UnitInterface";
import { PersonInterface } from "../../../Entity/Entities/Person/PersonInterface";
import { CompanyInterface } from "../../../Entity/Entities/Company/CompanyInterface";
import { ChargeTemplateInterface } from "../../../Entity/Entities/Charge/ChargeTemplateInterface";
import { DatePickerComponent } from "../../Partials/DatePicker/DatePickerComponent";
import PersonLookup from "../../Partials/Lookup/PersonLookup";
import UnitLookup from "../../Partials/Lookup/UnitLookup";
import { Tenant } from "../../../Entity/Entities/Person/Role/Roles/Tenant";
import { None } from "../../../Entity/Entities/Person/Role/Roles/None";
import { Occupant as OccupantRole } from "../../../Entity/Entities/Person/Role/Roles/Occupant";
import { Occupant as OccupantType } from "../../../Entity/Entities/ContactForContract/Type/Types/Occupant";
import { ChargeTemplateCreate } from "../../Partials/Dialog/ChargeTemplateCreate";
import { ChargeTemplateUpdate } from "../../Partials/Dialog/ChargeTemplateUpdate";
import { MiddlewareInterface } from "../../../Middleware/MiddlewareInterface";
import ContractExtendWillMount from "../../../Middleware/Middlewares/ContractExtendWillMount";
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import Card from '@material-ui/core/Card';
import IconButton from '@material-ui/core/IconButton';
import TextField from "../../Partials/Material/TextField";
import Button from '@material-ui/core/Button';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import PreventPageLeave from "../../../Middleware/Middlewares/PreventPageLeave";
import { PageTransition } from "../../Partials/Spinner/PageTransition";
import Formatter from "../../../Localization/Formatter";
import { AgencyFeeInterface } from "../../../Entity/Entities/AgencyFee/AgencyFeeInterface";
import { DeleteEntityPrompt } from "../../Partials/Dialog/DeleteEntityPrompt";
import AgencyFeeFactory from "../../../Entity/Factories/AgencyFeeFactory";
import PeriodContainer from "../../../Entity/Entities/Charge/Period/PeriodContainer";
import Translator from "../../../Translation/Translator";
import * as ReactTooltip from "react-tooltip";
import CurrencyContainer from "../../../Currency/CurrencyContainer";
import TypeContainer from "../../../Entity/Entities/Charge/Type/TypeContainer";
import * as uuidV4 from "uuid/v4";
import Searchbar from "../../Partials/Searchbar/Searchbar";
import { Company } from "../../../Entity/Entities/Company/Company";
import { Person } from "../../../Entity/Entities/Person/Person";
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import { CoachNewTenantDialog } from "../../Partials/Dialog/CoachNewTenantDialog";
import ChargeTemplateCard from "../../Partials/ChargeTemplate/ChargeTemplateCard";

class ContractExtend extends Component {
  private shortContractWarningPeriod: number = 1000 * 60 * 60 * 24 * 5;

  public state = {
    ignoredPeople: [],
    id: 0,
    extensionDate: Time.firstDateNextMonth(),
    lastDate: null,
    finalRentalPeriodDate: null,
    endDate: null,
    expirationDate: null,
    rentNotificationText: this.trans("notification_rent_message"),
    openLeavePrompt: false,
    datepickerError: "",
    datepickerHint: "",
    amazonFolderName: uuidV4(),
    canSelectTenant: false,
    isDialogOpen: false,
    isUpdating: false,
    openContractSigningDialog: false,
    payChargesUntilDate: Time.lastDatePreviousMonth(),
    isSetPaymentUntilDateChecked: false,
    note: "",
    hasModifiedData: false,
    errorForPerson: "",
    errorForUnit: "",
    relateWithPersonId: null,
    isEndContractDialogOpen: false,
    isExpirationContractDialogOpen: false,
    openDepositChargeWarningDialog: false,
    contractConceptCreatingPopupOpen: false,
    firstTimeDepositTemplateWarning: true,
    renewStartPopup: true,
    finishPopupOpen: false,
    isSaving: false,
    isAgencyFeeDialogOpen: false,
    agencyFee: null,
    anchorElAgencyFees: null,
    isAgencyRemoveDialog: false,
    beta: false,
    defaultAgencyFees: [],
    attachments: [],
    tooltipOpen: false,
    selectedTenant: null,
    selectedUnit: null,
    additionalFields: [],
    lastSelectedIndex: null,
    createdContract: null,
    selectedAgencyFee: null,
    previousContract: null,
    autoSendInvoiceToTenant: false,
    isCommercial: false,
    openCoachCreateNewTenant: false,
    isPaidDirectlyToOwner: false,

    // charge templates
    chargeTemplates: [],
    isChargeTemplatePopupOpen: false,
    newChargeTemplatePopupOpen: null,
    anchorElChargeTemplate: null,
    selectedChargeTemplate: null,
    isCalculatePricePopupOpen: false,
    priceOldAmount: "",
    priceNewAmount: "",
    pricePercentage: "0",
    chargeTemplateInitialAmounts: {},
    selectedChargeIndex: null
  };

  protected shouldClearBeforeUnmounting: boolean = true;
  protected clearWith: string = Constants.GLOBAL_CONTRACT_EXTEND_CLEAR;
  protected middlewares: MiddlewareInterface[] = [
    ContractExtendWillMount,
    PreventPageLeave
  ];

  constructor(public props) {
    super(props);
  }

  public componentWillUnmount() {
    document.removeEventListener('click', this.clickOutside, false);
  }

  public componentDidMount() {
    document.addEventListener('click', this.clickOutside, false);
    // We have to have a short delay otherwise focus does not work in Safari and Chrome.
    setTimeout(() => {
      // If we can auto-select an entity, we should also make next button clickable.
      if (typeof this.state.selectedTenant?.id === "number") {
        this.setModifiedData();
        return;
      }

      // Otherwise, we have to focus the PersonLookup component because of user experience...
      (this.refs.TenantLookup as any) && (this.refs.TenantLookup as any).refs.instance.ref.focus();
    }, 10);
  }

  public openEndContractDialog = () => {
    this.setState({
      isEndContractDialogOpen: true
    });
  }

  public closeEndContractDialog = () => {
    this.setState({
      isEndContractDialogOpen: false
    });
  }

  public openExpirationContractDialog = () => {
    this.setState({
      isExpirationContractDialogOpen: true
    });
  }

  public closeExpirationContractDialog = () => {
    this.setState({
      isExpirationContractDialogOpen: false
    });
  }

  public switchIsPaidDirectlyToOwner = () => {
    const chargeTemplates = this.state.chargeTemplates.map(template => {
      template.isPaidDirectlyToOwner = !this.state.isPaidDirectlyToOwner
      return template
    })
    const isPaidDirectlyToOwner = !this.state.isPaidDirectlyToOwner

    this.setState({
      chargeTemplates,
      isPaidDirectlyToOwner,
    });
  }

  public addAdditionalFields = (): void => {
    const additionalFields = [...this.state.additionalFields];

    additionalFields.push({
      selectedPerson: null,
      description: this.trans("label-occupant"),
      contactForContractTypeId: OccupantType.contactForContractTypeId
    });

    this.setState({ additionalFields: [...additionalFields] });

    this.forceUpdate();
  }

  public renderAdditionalFields = (): any => {
    return this.state.additionalFields.map((data: any, index: number) => {
      if (!data) {
        return;
      }

      return (
        <div
          key={index}
          style={{ margin: "-14px 0", position: "relative" }}
        >
          <PersonLookup
            {...this.props}
            filterOutEntities={this.state.additionalFields}
            isInlineBlock={true}
            width="100%"
            containerWidth="60%"
            onFocus={() => this.setState({ lastSelectedIndex: index })}
            autoSelectId={data && data.selectedPerson ? data && data.selectedPerson.id : null}
            floatingLabelText={this.trans("dropdown-selectperson-label")}
            onSelect={this.selectAdditionalPerson}
            onClear={person => {
              const additionalFields = [...this.state.additionalFields];
              additionalFields[index].selectedPerson = null;

              this.setState({
                additionalFields: [...additionalFields],
                ignoredPeople: this.state.ignoredPeople.filter(p => p.id !== person.id)
              }, () => {
                this.setModifiedData();
              });
            }}
            forceUpdatePage={true}
            saveDetailsBeforeRedirect={this.saveDetailsBeforeRedirect.bind(this)}
            error={this.getErrorFor(`contactForContracts[${index + 1}].contactId`)}
          />

          <TextField
            autoComplete="off"
            className="form-element"
            style={{ width: "30%", boxSizing: "border-box", marginLeft: "45px" }}
            type="text"
            label={this.trans("label-description")}
            value={this.state.additionalFields[index].description}
            onChange={e => {
              const additionalFields = [...this.state.additionalFields];
              additionalFields[index].description = (e.currentTarget as any).value;
              this.setState({ additionalFields: [...additionalFields] });
              this.setModifiedData();
            }}
            variant="standard"
            error={false}
          />

          <div
            className="icon icon-ic-close clear-button"
            style={{
              display: "inline-block",
              position: "absolute",
              top: "25px",
              right: "0px",
              cursor: "pointer"
            }}
            onClick={this.removeAdditionalField.bind(this, index)}
          ></div>
        </div>
      );
    });
  }

  public removeAdditionalField = (index: number): void => {
    const additionalFields = [...this.state.additionalFields];
    additionalFields.splice(index, 1);

    this.setState({
      additionalFields: [...additionalFields],
      hasModifiedData: true
    });

    this.forceUpdate();
  }

  public selectDate = (momentDate: any, identifier: string): any => {
    const date = !!momentDate && typeof momentDate.toDate === "function" ? momentDate.toDate() : momentDate;
    const prevExtensionDate = !!this.state.extensionDate ? new Date(this.state.extensionDate) : null;
    // const prevLastDate = !!this.state.lastDate ? new Date(this.state.lastDate) : null;
    // const prevFinalDate = !!this.state.finalRentalPeriodDate ? new Date(this.state.finalRentalPeriodDate) : null;
    // const prevExpirationDate = !!this.state.expirationDate ? new Date(this.state.expirationDate) : null;

    // Update the state
    this.setState({
      [identifier]: date,
      hasModifiedData: true,
      datepickerHint: "",
      datepickerError: ""
    }, () => {
      // Show the hint if contract period is pretty short, like 5-6 days
      if (!!this.state.extensionDate && !!this.state.lastDate &&
        (this.state.lastDate.getTime() - this.state.extensionDate.getTime()) <= this.shortContractWarningPeriod) {
        this.setState({
          datepickerHint: this.trans("last-date-of-period-pretty-close")
        });
      }

      // when we change first date we also should syncronize value of last date if it wasn't changed manually
      if (identifier === "extensionDate") {
        // we should also update the dates in charge templates
        // Put the current charge templates to the state of the component
        this.setState({
          chargeTemplates: this.state.chargeTemplates.map((chargeTemplate: ChargeTemplateInterface) => {

            let chargeTemplateFirstDate = chargeTemplate?.firstDate;
            let chargeTemplateDueDateFirstPayment = chargeTemplate?.dueDateFirstPayment;

            if (!!this.state.extensionDate && !!chargeTemplate?.firstDate &&
              this.formatter.formatDate(prevExtensionDate) === this.formatter.formatDate(chargeTemplate?.firstDate)) {
              chargeTemplateFirstDate = this.state.extensionDate;
            }

            if (!this.state.extensionDate && !!chargeTemplate?.firstDate &&
              this.formatter.formatDate(prevExtensionDate) === this.formatter.formatDate(chargeTemplate?.firstDate)) {
              chargeTemplateFirstDate = this.state.extensionDate;
            }

            if (!!this.state.extensionDate && !prevExtensionDate && !chargeTemplate?.firstDate) {
              chargeTemplateFirstDate = this.state.extensionDate;
            }

            if (!!this.state.extensionDate && !!chargeTemplate?.dueDateFirstPayment &&
              this.formatter.formatDate(prevExtensionDate) === this.formatter.formatDate(chargeTemplate?.dueDateFirstPayment)) {
              chargeTemplateDueDateFirstPayment = this.state.extensionDate;
            }

            if (!this.state.extensionDate && !!chargeTemplate?.dueDateFirstPayment &&
              this.formatter.formatDate(prevExtensionDate) === this.formatter.formatDate(chargeTemplate?.dueDateFirstPayment)) {
              chargeTemplateDueDateFirstPayment = this.state.extensionDate;
            }

            if (!!this.state.extensionDate && !prevExtensionDate && !chargeTemplate?.dueDateFirstPayment) {
              chargeTemplateDueDateFirstPayment = this.state.extensionDate;
            }
            return {
              ...chargeTemplate,
              firstDate: chargeTemplateFirstDate,
              dueDateFirstPayment: chargeTemplateDueDateFirstPayment,
            }
          })
        });

        // we should update last date if it wasn't changed manually
        // if (!!this.state.extensionDate && !!this.state.lastDate &&
        //   this.formatter.formatDate(Time.nextYearPrevMonthLastDay(prevExtensionDate)) === this.formatter.formatDate(this.state.lastDate)) {
        //     return this.selectDate(Time.nextYearPrevMonthLastDay(this.state.extensionDate), "lastDate");
        // }

        // if (!this.state.extensionDate && !!this.state.lastDate &&
        //     this.formatter.formatDate(Time.nextYearPrevMonthLastDay(prevExtensionDate)) === this.formatter.formatDate(this.state.lastDate)) {
        //   return this.selectDate(this.state.extensionDate, "lastDate");
        // }

        // if (!!this.state.extensionDate && !prevExtensionDate && !this.state.lastDate) {
        //   return this.selectDate(Time.nextYearPrevMonthLastDay(this.state.extensionDate), "lastDate");
        // }
      }

      // If the identifier is lastDate, we also have to update finalRentalPeriodDate and expirationDate
      // if they were not updated manually
      // if (identifier === "lastDate") {
      //   if (!!this.state.lastDate && !!this.state.finalRentalPeriodDate &&
      //     this.formatter.formatDate(prevLastDate) === this.formatter.formatDate(this.state.finalRentalPeriodDate)) {
      //       this.selectDate(this.state.lastDate, "finalDate");
      //   }

      //   if (!this.state.lastDate && !!this.state.finalRentalPeriodDate &&
      //     this.formatter.formatDate(prevLastDate) === this.formatter.formatDate(this.state.finalRentalPeriodDate)) {
      //      this.selectDate(date, "finalDate");
      //   }

      //   if (!!this.state.lastDate && !prevLastDate && !prevFinalDate) {
      //     this.selectDate(date, "finalDate");
      //   }

      //   if (!!this.state.lastDate && !!this.state.expirationDate &&
      //     this.formatter.formatDate(Time.substractMonth(prevLastDate, this.props.app.settings.agency.notificationPeriod)) === this.formatter.formatDate(this.state.expirationDate)) {
      //       return this.selectDate(Time.substractMonth(this.state.lastDate, this.props.app.settings.agency.notificationPeriod), "expirationDate");
      //   }

      //   if (!this.state.lastDate && !!this.state.expirationDate &&
      //       this.formatter.formatDate(Time.substractMonth(prevLastDate, this.props.app.settings.agency.notificationPeriod)) === this.formatter.formatDate(this.state.expirationDate)) {
      //       return this.selectDate(this.state.lastDate, "expirationDate");
      //   }

      //   if (!!this.state.lastDate && !prevLastDate && !prevExpirationDate) {
      //     return this.selectDate(Time.substractMonth(this.state.lastDate, this.props.app.settings.agency.notificationPeriod), "expirationDate");
      //   }
      // }
    });
  }

  public openChargeTemplateCreatePopup = () => {
    this.props.dispatch({
      type: Constants.GLOBAL_CHARGE_TYPE_CREATE_CLEAR,
    });

    this.props.dispatch({
      type: Constants.GLOBAL_CHARGE_TYPE_UPDATE_CLEAR,
    });

    this.setState({
      newChargeTemplatePopupOpen: true,
    }, () => {
      this.setState({
        isChargeTemplatePopupOpen: true
      })
    });
  }

  public closeChargeTemplatePopup = () => {
    this.setState({
      isChargeTemplatePopupOpen: false,
      isCalculatePricePopupOpen: false,
      isUpdating: false
    });
  }

  public save = () => {
    const payload: any = {
      сreatedOnFrontend: true,
      id: this.state.id,
      unit: this.state.selectedUnit,
      amazonFolderName: this.state.amazonFolderName,
      extensionDate: this.state.extensionDate,
      lastDate: this.state.lastDate,
      finalRentalPeriodDate: this.state.finalRentalPeriodDate,
      endDate: this.state.endDate,
      expirationDate: this.state.expirationDate,
      text: this.state.rentNotificationText,
      payChargesUntilDate: this.state.isSetPaymentUntilDateChecked === true ? this.state.payChargesUntilDate : null,
      note: this.state.note,
      chargeTemplates: this.state.chargeTemplates
        .filter((chargeTemplate: ChargeTemplateInterface) => !chargeTemplate?.unitId),
      additionalFields: this.state.additionalFields,
      agencyFee: this.state.defaultAgencyFees[0],
      autoSendInvoiceToTenant: this.state.autoSendInvoiceToTenant,
      isCommercial: this.state.isCommercial,
    };

    if (this.state.selectedTenant instanceof Person) {
      payload.selectedPerson = this.state.selectedTenant;
    }

    if (this.state.selectedTenant instanceof Company) {
      payload.selectedCompany = this.state.selectedTenant;
    }

    this.saving(() => {
      this.props.dispatch({
        type: Constants.GLOBAL_CONTRACT_EXTEND_START,
        payload: {
          ...payload
        },
        onSuccess: () => {
          this.props.dispatch({
            type: Constants.SAVED_DATA_BEFORE_REDIRECTING_CLEAR
          });

          if (this.browser.history.getPreviousPage()?.includes("contract/update")) {
            return this.redirectFewStepsBack(2);
          } else {
            return this.redirectBack();
          }
        },
        onError: (err) => {
          const showAgencyFeeErrorDialog = err.fields?.some(field => field === "agencyFee.percentageFee")
          const showChargeTemplateErrorDialog = err.fields?.some(field => field.indexOf("chargeTemplates") === 0)
          let chargeTemplatesErrorRows = [];

          let chargeTemplatesErrorIndexRows = err.fields?.filter(field => field.indexOf("chargeTemplates") === 0)
            .map(field => parseInt(field.match(/\d+/)));

          let chargeTemplatesError = err.fields?.filter(field => field.indexOf("chargeTemplates") === 0)
          let chargeTemplatesErrorField;
          if (chargeTemplatesError[0]) {
            chargeTemplatesErrorField = chargeTemplatesError[0].split(".")
            chargeTemplatesErrorRows.push(chargeTemplatesErrorIndexRows[0]); // just set first error from array
          }



          const chargeTemplates = this.state.chargeTemplates.map((chargeTemplate, index) => {
            return {
              ...chargeTemplate,
              error: chargeTemplatesErrorRows?.some(field => field === index)
            }
          })

          this.setState({
            chargeTemplates: chargeTemplates,
            isSaving: false,
            hasModifiedData: true
          })

          if (showAgencyFeeErrorDialog) {
            this.props.dispatch({
              type: Constants.SNACKBAR_ADD_MESSAGE,
              payload: {
                message: this.trans("error-notvaliddatata-agencyfee"),
                type: "error"
              }
            });
          }

          if (showChargeTemplateErrorDialog) {
            this.props.dispatch({
              type: Constants.SNACKBAR_ADD_MESSAGE,
              payload: {
                message: this.trans("error-notvaliddatata-chargetemplate", { field: this.trans(`label-${chargeTemplatesErrorField[1]}`) }),
                type: "error"
              }
            });
          }
        }
      });
    });
  }

  protected openChargeTemplateMenu = (event: any, chargeTemplate: ChargeTemplateInterface, index): void => {
    this.props.dispatch({
      type: Constants.GLOBAL_CHARGE_TEMPLATE_CREATE_CLEAR,
    });

    this.props.dispatch({
      type: Constants.GLOBAL_CHARGE_TEMPLATE_UPDATE_CLEAR,
    });

    this.setState({
      selectedChargeTemplate: chargeTemplate,
      anchorElChargeTemplate: event.currentTarget,
      selectedChargeIndex: index
    });
  }

  protected closeChargeTemplateMenu = (): void => {
    this.setState({
      anchorElChargeTemplate: null
    });
  }

  public openCalculatePricePopup = (chargeTemplate, index): any => {
    const priceOldAmount = chargeTemplate?.oldAmount ?
      this.formatter.simpleFormatNumber(chargeTemplate?.oldAmount * 100) :
      this.formatter.simpleFormatNumber(chargeTemplate?.amount * 100);

    this.setState({
      selectedChargeIndex: index,
      selectedChargeTemplate: chargeTemplate,
      isUpdating: true,
      isCalculatePricePopupOpen: true,
      priceOldAmount: priceOldAmount,
      priceNewAmount: chargeTemplate?.amount
    });
  }

  public changePriceNewAmount = (event): void => {
    const newAmount: string = this.formatter.formatSigns(event.target.value);
    this.setState({
      priceNewAmount: newAmount
    });
  }

  public changePricePercentage = (event): void => {
    const percentage: string = this.formatter.formatSigns(event.target.value);
    const percentageNumber: number = parseFloat(parseFloat(String(Formatter.deleteExtraSpace(percentage)).replace(",", ".")).toFixed(2));
    const priceNewAmount: number = this.state.selectedChargeTemplate?.amount + this.state.selectedChargeTemplate?.amount * (percentageNumber / 100);

    this.setState({
      pricePercentage: percentage,
      priceNewAmount: this.formatter.simpleFormatNumber(priceNewAmount * 100)
    });
  }

  public comparer = (a, b) => {
    if (a > b) {
      return 1;
    }
    if (a < b) {
      return -1;
    }

    return 0;
  }

  public chargeTemplateComparer = (a, b) => {
    return this.comparer(a?.repeatPeriod, b?.repeatPeriod) ||
      this.comparer(TypeContainer.pickLabelFromId(a?.type), TypeContainer.pickLabelFromId(b?.type));
  }

  public getChargeTemplates = () => {
    return [...this.state.chargeTemplates]
      .filter((chargeTemplate: ChargeTemplateInterface) => !!chargeTemplate)
      .map((chargeTemplate, index) => {
        return (
          <TableRow
            hover
            key={`chargeTemplate-${index}`}
            className={`clickable-entity`}
            onClick={() => {
              this.openChargeTemplateUpdatePopup(chargeTemplate, index);
            }}
          >
            <TableCell>
              {chargeTemplate?.error &&
                <div style={{ display: "flex", alignItems: "center", justifyContent: "center", paddingTop: "6px" }}>
                  <div
                    className="icon icon-ic-info red"
                  >
                  </div>
                </div>
              }
            </TableCell>
            <TableCell style={{ minWidth: "150px" }}>
              <div style={{ display: "flex", justifyContent: "flex-start", alignItems: "center" }}>
                <div style={{ minWidth: "105px" }}>
                  {this.formatter.formatNumber(chargeTemplate?.amount * 100, CurrencyContainer.pickFromId(chargeTemplate?.currency))}
                </div>
                <div>
                  <div data-tip={this.trans("page/renewcontract-section/prices-icon/updatecontractprice-tip")}>
                    <div className="icon icon-ic-calculator blue-onhover"
                      style={{ margin: "5px 0 0 10px", color: "#00BCD4" }}
                      onClick={e => {
                        e.stopPropagation();
                        this.openCalculatePricePopup(chargeTemplate, index);
                      }}
                    >
                    </div>
                  </div>
                  <ReactTooltip place="bottom" />
                </div>
              </div>
            </TableCell>
            <TableCell style={{ width: "15%" }}>{Formatter.checkTranslationType(this.trans(PeriodContainer.pickLabelFromId(chargeTemplate.repeatPeriod)), PeriodContainer.pickLabelFromId(chargeTemplate.repeatPeriod))}</TableCell>
            <TableCell style={{ width: "20%" }}>{Formatter.checkTranslationType(this.trans(TypeContainer.pickLabelFromId(chargeTemplate.type), {}, "", false), TypeContainer.pickLabelFromId(chargeTemplate.type), chargeTemplate?.type?.system)}</TableCell>
            <TableCell style={{ width: "10%" }}>
              {
                chargeTemplate?.isPaidDirectlyToOwner && (
                  <div style={{ padding: "2px", display: "flex", justifyContent: "center", alignItems: "center" }}>
                    <div className="list-label creation-type-label">
                      {this.trans("label-direct")}
                    </div>
                  </div>

                )
              }
            </TableCell>
            <TableCell style={{ width: "20%" }}>{chargeTemplate.description}</TableCell>
            <TableCell style={{ width: "15%" }}>{this.formatter.formatDate(chargeTemplate.dueDateFirstPayment) || this.formatter.formatDate(chargeTemplate.firstDate)}</TableCell>
            <TableCell
              onClick={e => {
                e.stopPropagation();
              }}
            >
              <div>
                <IconButton
                  onClick={e => this.openChargeTemplateMenu(e, chargeTemplate, index)}
                >
                  <div className="icon icon-ic-more-vert"></div>
                </IconButton>
                <Menu
                  id="simple-menu"
                  anchorEl={this.state.anchorElChargeTemplate}
                  open={Boolean(this.state.anchorElChargeTemplate) && this.state.selectedChargeIndex === index}
                  onClose={this.closeChargeTemplateMenu}
                  disableAutoFocusItem={true}
                  anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "center"
                  }}
                  transformOrigin={{
                    vertical: "top",
                    horizontal: "left"
                  }}
                  getContentAnchorEl={null}
                >
                  <MenuItem
                    onClick={() => this.openChargeTemplateUpdatePopup(this.state.selectedChargeTemplate, this.state.selectedChargeIndex)}
                  >
                    <ListItemIcon><div className="icon icon-ic-edit icon-color"></div></ListItemIcon>
                    <ListItemText>{this.trans("menuitem-open")}</ListItemText>
                  </MenuItem>
                  <MenuItem
                    className="delete-action"
                    onClick={() => this.deleteChargeTemplate()}
                  >
                    <ListItemIcon><div className="icon icon-ic-remove icon-color remove-icon"></div></ListItemIcon>
                    <ListItemText>{this.trans("menuitem-delete")}</ListItemText>
                  </MenuItem>
                </Menu>
              </div>
            </TableCell>
          </TableRow>
        );
      });
  }

  public selectAdditionalPerson = (person: PersonInterface, isManuallySelected: boolean): void => {
    const additionalFields = [...this.state.additionalFields];

    if (isManuallySelected === true) {
      additionalFields[this.state.lastSelectedIndex].selectedPerson = person;
    }

    this.setState({
      hasModifiedData: isManuallySelected,
      additionalFields: [...additionalFields],
      ignoredPeople: [person, ...this.state.ignoredPeople]
    });
  }

  public addChargeTemplate = (chargeTemplate): any => {
    let createdChargeTemplate = { ...chargeTemplate };

    const chargeTemplates = [...this.state.chargeTemplates, chargeTemplate];
    chargeTemplates.sort(this.chargeTemplateComparer)

    this.setState({
      hasModifiedData: true,
      isChargeTemplatePopupOpen: false,
      chargeTemplates: chargeTemplates.map(chargeTemplate => {
        return {
          ...chargeTemplate,
          isPaidDirectlyToOwner: createdChargeTemplate?.isCollective && chargeTemplate?.isCollective ? createdChargeTemplate?.isPaidDirectlyToOwner : chargeTemplate?.isPaidDirectlyToOwner
        }
      }),
    }, () => {
      this.setState({
        isUpdating: false
      })
    })
  }

  public openChargeTemplateUpdatePopup = (chargeTemplate: ChargeTemplateInterface, index): any => {
    this.setState({
      selectedChargeIndex: index,
      selectedChargeTemplate: chargeTemplate,
      isUpdating: true,
      anchorElChargeTemplate: null,
      newChargeTemplatePopupOpen: false
    }, () => {
      this.setState({
        isChargeTemplatePopupOpen: true,
        isUpdating: true
      })
    });
  }

  public updateChargeTemplate = (updatedChargeTemplate): any => {
    let updatedChargeTemplates = this.state.chargeTemplates;
    updatedChargeTemplates.splice(this.state.selectedChargeIndex, 1, updatedChargeTemplate)
    updatedChargeTemplates.sort(this.chargeTemplateComparer)

    this.setState({
      chargeTemplates: updatedChargeTemplates.map(chargeTemplate => {
        return {
          ...chargeTemplate,
          isPaidDirectlyToOwner: updatedChargeTemplate?.isCollective && chargeTemplate?.isCollective ? updatedChargeTemplate?.isPaidDirectlyToOwner : chargeTemplate?.isPaidDirectlyToOwner
        }
      }),
      hasModifiedData: true,
      isChargeTemplatePopupOpen: false,
      isUpdating: false,
      selectedChargeIndex: null,
      isCalculatePricePopupOpen: false,
      pricePercentage: "0"
    })
  }

  public deleteChargeTemplate = (): any => {
    this.closeChargeTemplateMenu();

    const updatedChargeTemplates = this.state.chargeTemplates;
    updatedChargeTemplates.splice(this.state.selectedChargeIndex, 1)
    updatedChargeTemplates.sort(this.chargeTemplateComparer)

    this.setState({
      chargeTemplates: updatedChargeTemplates,
      hasModifiedData: true,
      isChargeTemplatePopupOpen: false,
      selectedChargeIndex: null
    })
  }

  public getChargeTemplatePopupContent = (): any => {
    if (this.state.isUpdating) {
      return (
        <ChargeTemplateUpdate
          {...this.props}
          entity={"contract"}
          chargeTemplate={this.state.selectedChargeTemplate}
          onSave={this.updateChargeTemplate}
          onCancel={this.closeChargeTemplatePopup}
          chargeTemplateCreatedOnFrontend={true}
        />
      );
    }

    return (
      <ChargeTemplateCreate
        {...this.props}
        entity={"contract"}
        selectedType={TypeContainer.pickIdFromLabel("Basic_rent")}
        firstDate={this.state.extensionDate ? new Date(this.state.extensionDate) : null}
        contact={this.state.selectedTenant instanceof Person ? this.state.selectedTenant : null}
        company={this.state.selectedTenant instanceof Company ? this.state.selectedTenant : null}
        onSave={this.addChargeTemplate}
        onCancel={this.closeChargeTemplatePopup}
        chargeTemplateCreatedOnFrontend={true}
        existingChargeTemplates={this.state.chargeTemplates}
      />
    );
  }

  public done = (): void => {
    this.props.dispatch({
      type: Constants.SAVED_DATA_BEFORE_REDIRECTING_CLEAR
    });

    this.redirectBack();
  }

  public handleCreatedPerson = (person: PersonInterface): void => {
    this.setState({
      relateWithPersonId: person.id
    });
  }

  public selectUnit = (unit: UnitInterface, isManuallySelected: boolean): void => {
    this.setState({
      selectedUnit: unit,
      hasModifiedData: isManuallySelected
    });
  }

  public clearUnit = (): void => {
    this.setState({
      selectedUnit: null,
      hasModifiedData: true
    });
  }

  public focusPerson = (): void => {
    (this.refs.PersonLookup as any).refs.instance.hide();
  }

  public focusUnit = (): void => {
    (this.refs.UnitLookup as any).refs.instance.hide();
  }

  public saveDetailsBeforeRedirect = () => {
    this.state.hasModifiedData = false;

    const savedDataBeforeRedirecting = { ...this.props.app.savedDataBeforeRedirecting };

    this.props.dispatch({
      type: Constants.SAVED_DATA_BEFORE_REDIRECTING_CLEAR
    });

    const dataToBeSaved = { ...this.state };
    dataToBeSaved.hasModifiedData = true;
    savedDataBeforeRedirecting.dataToBeSaved = dataToBeSaved;

    this.props.dispatch({
      type: Constants.SAVED_DATA_BEFORE_REDIRECTING,
      payload: {
        savedDataBeforeRedirecting: { ...savedDataBeforeRedirecting }
      }
    });

    let contactRoleId = Tenant.contactRoleId;
    const indexForAdditionalPerson = this.state.lastSelectedIndex;

    if (Number.isInteger(indexForAdditionalPerson)) {
      if (this.state.additionalFields[indexForAdditionalPerson].contactForContractTypeId === 2) {
        contactRoleId = OccupantRole.contactRoleId;
      }

      if (this.state.additionalFields[indexForAdditionalPerson].contactForContractTypeId === 255) {
        contactRoleId = None.contactRoleId;
      }
    }

    this.props.dispatch({
      type: Constants.SAVED_DATA_BEFORE_REDIRECTING,
      payload: {
        savedDataBeforeRedirecting: {
          dataToBeSaved: dataToBeSaved,
          contractRoleId: contactRoleId,
          indexForAdditionalPerson: indexForAdditionalPerson
        }
      }
    });
  }

  public redirectToUnit = () => {
    const contract = this.props.app.contracts.filter(contract => contract.id === this.state.id)[0];

    return this.redirect(`/app/unit/update/${contract.unit.id}/#contractList`);
  }

  public openAgencyFeeDialog = () => {
    return this.setState({
      isAgencyFeeDialogOpen: true
    });
  }

  public closeAgencyFeeDialog = () => {
    // sending empty error array to clear page errors
    this.props.dispatch({
      type: Constants.GLOBAL_AGENCY_FEE_CREATE_FAILURE,
      payload: {
        err: []
      }
    });

    this.setState({
      isAgencyFeeDialogOpen: false,
      isUpdating: false
    });
  }

  public addAgencyFee = (agencyFee): any => {
    if (agencyFee.chargeTypeIds.length === 0) {
      return this.props.dispatch({
        type: Constants.GLOBAL_AGENCY_FEE_CREATE_FAILURE,
        payload: {
          err: {
            fields: ["chargeTypeIds"],
            translatedMessage: this.trans("be_ajv_not_validated")
          }
        }
      });
    } else {
      this.props.dispatch({
        type: Constants.GLOBAL_AGENCY_FEE_CREATE_FAILURE,
        payload: {
          err: []
        }
      });
    }

    if (!agencyFee.fixedFee && !agencyFee.percentageFee || (agencyFee.fixedFee === 0 && agencyFee.percentageFee === 0)) {
      this.props.dispatch({
        type: Constants.SNACKBAR_ADD_MESSAGE,
        payload: {
          message: this.trans("should_be_filled_one_of_the_fees_types"),
          type: "error"
        }
      });
      return;
    }

    const fixedFee = parseFloat((100 * parseFloat(String(Formatter.deleteExtraSpace(agencyFee.fixedFee)).replace(",", "."))).toFixed(2));
    const percentageFee = parseFloat(Formatter.deleteExtraSpace(agencyFee.percentageFee).replace(",", "."));
    agencyFee.fixedFee = isNaN(fixedFee) ? null : fixedFee;
    agencyFee.percentageFee = isNaN(agencyFee.percentageFee) ? null : percentageFee;
    const createdAgencyFee: AgencyFeeInterface = AgencyFeeFactory.create(agencyFee);

    this.setState({
      hasModifiedData: true,
      defaultAgencyFees: [createdAgencyFee]
    }, this.closeAgencyFeeDialog);
  }

  public updateAgencyFee = (agencyFee: AgencyFeeInterface): any => {
    this.setState({
      selectedAgencyFee: agencyFee,
      hasModifiedData: true,
      isUpdating: true,
      anchorElAgencyFees: null
    }, () => {
      this.openAgencyFeeDialog();
    });
  }

  public saveAgencyFee = (agencyFee: AgencyFeeInterface): any => {
    if (agencyFee.chargeTypeIds.length === 0) {
      return this.props.dispatch({
        type: Constants.GLOBAL_AGENCY_FEE_CREATE_FAILURE,
        payload: {
          err: {
            fields: ["chargeTypeIds"],
            translatedMessage: this.trans("be_ajv_not_validated")
          }
        }
      });
    } else {
      this.props.dispatch({
        type: Constants.GLOBAL_AGENCY_FEE_CREATE_FAILURE,
        payload: {
          err: []
        }
      });
    }

    if (!agencyFee.fixedFee && !agencyFee.percentageFee || (agencyFee.fixedFee === 0 && agencyFee.percentageFee === 0)) {
      this.props.dispatch({
        type: Constants.SNACKBAR_ADD_MESSAGE,
        payload: {
          message: this.trans("should_be_filled_one_of_the_fees_types"),
          type: "error"
        }
      });
      return;
    }

    const fixedFee = parseFloat((100 * parseFloat(String(Formatter.deleteExtraSpace(String(agencyFee.fixedFee))).replace(",", "."))).toFixed(2));
    const percentageFee = parseFloat(Formatter.deleteExtraSpace(String(agencyFee.percentageFee)).replace(",", "."));
    agencyFee.fixedFee = isNaN(fixedFee) ? null : fixedFee;
    agencyFee.percentageFee = isNaN(agencyFee.percentageFee) ? null : percentageFee;
    const createdAgencyFee: AgencyFeeInterface = AgencyFeeFactory.create(agencyFee);

    this.setState({
      hasModifiedData: true,
      defaultAgencyFees: [createdAgencyFee]
    }, this.closeAgencyFeeDialog);
  }

  public deleteAgencyFee = () => {
    this.setState({
      hasModifiedData: true,
      defaultAgencyFees: [],
      isAgencyRemoveDialog: false,
      agencyFee: null
    });
  }

  public closePrompt = (): void => {
    this.setState({
      isAgencyRemoveDialog: false,
    })
  }

  protected openMenuAgencyFees = (event: any, agencyFee: AgencyFeeInterface): void => {
    this.setState({
      selectedAgencyFee: agencyFee,
      anchorElAgencyFees: event.currentTarget
    });
  }

  protected closeMenuAgencyFees = (): void => {
    this.setState({
      anchorElAgencyFees: null
    });
  }

  public getDefaultAgencyFees = () => {
    return this.state.defaultAgencyFees && this.state.defaultAgencyFees.map((agencyFee: AgencyFeeInterface) => {
      return (
        <TableRow
          hover
          key={agencyFee.id}
          className={`clickable-entity`}
          onClick={() => {
            this.updateAgencyFee(agencyFee);
          }}
        >
          <TableCell>
          </TableCell>
          <TableCell style={{ width: "30%" }}>
            {this.formatter.formatNumber(agencyFee.fixedFee, agencyFee.currency)}
          </TableCell>
          <TableCell style={{ width: "30%" }}>{`${this.formatter.simpleFormatNumber(agencyFee.percentageFee, false)}%`}</TableCell>
          <TableCell style={{ width: "35%" }}>{Formatter.checkTranslationType(this.trans(agencyFee.fixedPlusPercentageMode.label), agencyFee.fixedPlusPercentageMode.label)}</TableCell>
          <TableCell
            style={{ width: "5%" }}
            onClick={e => {
              e.stopPropagation();
            }}
          >
            <div>
              <IconButton
                onClick={e => this.openMenuAgencyFees(e, agencyFee)}
              >
                <div className="icon icon-ic-more-vert"></div>
              </IconButton>
              <Menu
                id="simple-menu"
                anchorEl={this.state.anchorElAgencyFees}
                open={Boolean(this.state.anchorElAgencyFees) && this.state.selectedAgencyFee?.id === agencyFee.id}
                onClose={this.closeMenuAgencyFees}
                disableAutoFocusItem={true}
                anchorOrigin={{
                  vertical: "bottom",
                  horizontal: "center"
                }}
                transformOrigin={{
                  vertical: "top",
                  horizontal: "left"
                }}
                getContentAnchorEl={null}
              >
                <MenuItem
                  onClick={() => this.updateAgencyFee(this.state.selectedAgencyFee)}
                >
                  <ListItemIcon><div className="icon icon-ic-edit icon-color"></div></ListItemIcon>
                  <ListItemText>{this.trans("menuitem-open")}</ListItemText>
                </MenuItem>
                <MenuItem
                  className="delete-action"
                  onClick={() => this.setState({ agencyFee: this.state.selectedAgencyFee, isAgencyRemoveDialog: true })}
                >
                  <ListItemIcon><div className="icon icon-ic-remove icon-color remove-icon"></div></ListItemIcon>
                  <ListItemText>{this.trans("menuitem-delete")}</ListItemText>
                </MenuItem>
              </Menu>
            </div>
          </TableCell>
        </TableRow>
      );
    });
  }

  public getAgencyFeeDialogTitle = (): string => {
    return this.trans("dialog/agencyfee-title");
  }

  public clickOutside = (e) => {
    if (e.target != document.getElementById('tooltip-block')) {
      if (e.target != document.getElementById('hidden-hint')) {
        this.setState({
          tooltipOpen: false
        });
      } else {
        this.setState({
          tooltipOpen: true
        });
      }
    }
  }

  public openTooltip = () => {
    this.setState({
      tooltipOpen: !this.state.tooltipOpen
    });
  }

  public renderNotificationDateQuicksets = () => {
    return (
      <div className="date-quickset-wrapper">
        <div
          className="date-quickset"
          onClick={() => this.selectDate(Time.useSetForExpirationDate(this.state.extensionDate, 6), "lastDate")}
        >
          6
        </div>
        <div
          className="date-quickset"
          onClick={() => this.selectDate(Time.useSetForExpirationDate(this.state.extensionDate, 12), "lastDate")}
        >
          12
        </div>
        <div
          className="date-quickset"
          onClick={() => this.selectDate(Time.useSetForExpirationDate(this.state.extensionDate, 24), "lastDate")}
        >
          24
        </div>
      </div>
    );
  }

  public renderExpirationDateQuicksets = () => {
    return (
      <div className="date-quickset-wrapper">
        <div
          className="date-quickset"
          onClick={() => this.selectDate(Time.substractMonth(this.state.lastDate, 1), "expirationDate")}
        >
          1
        </div>
        <div
          className="date-quickset"
          onClick={() => this.selectDate(Time.substractMonth(this.state.lastDate, 2), "expirationDate")}
        >
          2
        </div>
        <div
          className="date-quickset"
          onClick={() => this.selectDate(Time.substractMonth(this.state.lastDate, 4), "expirationDate")}
        >
          4
        </div>
      </div>
    );
  }

  public selectTenant = (entity: CompanyInterface | PersonInterface, fromCoach: boolean): void => {
    this.setState({
      selectedTenant: entity,
      ignoredPeople: entity instanceof Person ? [entity, ...this.state.ignoredPeople] : [...this.state.ignoredPeople],
      hasModifiedData: true,
      openCoachCreateNewTenant: (entity instanceof Company && !entity?.generalContactId && !fromCoach) ? true : false,
      chargeTemplates: this.state.chargeTemplates.map((chargeTemplate: ChargeTemplateInterface) => {
        let contactId = chargeTemplate?.contactId;
        let companyId = chargeTemplate?.companyId;

        if (entity instanceof Person) {
          if (entity?.id) {
            contactId = entity?.id;
            companyId = undefined;
          }
        }

        if (entity instanceof Company) {
          if (entity?.id) {
            companyId = entity?.id;
            contactId = undefined;
          }
        }

        return {
          ...chargeTemplate,
          contactId: contactId,
          companyId: companyId
        }
      })
    });
  }

  public clearTenant = (): void => {
    this.setState({
      selectedTenant: null,
      hasModifiedData: true,
      chargeTemplates: this.state.chargeTemplates.map((chargeTemplate: ChargeTemplateInterface) => {
        let contactId = chargeTemplate?.contactId;
        let companyId = chargeTemplate?.companyId;

        if (this.state.selectedTenant instanceof Person) {
          if ((this.state.selectedTenant?.id && chargeTemplate?.contactId && this.state.selectedTenant?.id === chargeTemplate?.contactId)) {
            contactId = null;
            companyId = undefined;
          }
        }

        if (this.state.selectedTenant instanceof Company) {
          if ((this.state.selectedTenant?.id && chargeTemplate?.companyId && this.state.selectedTenant?.id === chargeTemplate?.companyId)) {
            companyId = null;
            contactId = undefined;
          }
        }

        return {
          ...chargeTemplate,
          contactId: contactId,
          companyId: companyId
        }
      })
    });
  }
  public changeAutoSendInvoiceToTenant = () => {
    this.setState({
      autoSendInvoiceToTenant: !this.state.autoSendInvoiceToTenant,
      hasModifiedData: true
    });
  }

  public changeIsCommercial = () => {
    this.setState({
      isCommercial: !this.state.isCommercial,
      hasModifiedData: true
    });
  }

  public render() {
    const monthlyChargeTemplatesAmount = [...this.state.chargeTemplates]
      .filter((chargeTemplate: ChargeTemplateInterface) =>
        !chargeTemplate?.contractId &&
        chargeTemplate?.repeatPeriod === PeriodContainer.pickIdFromLabel("monthly") &&
        chargeTemplate?.amount
      )
      .map((chargeTemplate: ChargeTemplateInterface) => chargeTemplate?.amount)
      .reduce((a, b) => a + b, 0);

    return (
      <div className="state-app">
        <div className="box box-full has-details-page-header">
          <div className="component-header has-back-button">
            <div className="inner-wrapper">
              <div className="back-arrow-wrapper" onClick={this.redirectBack}>
                <div className="icon icon-ic-arrow-back icon-color"></div>
              </div>
              <h1>{this.trans("renew-contract")}</h1>
              <div className="button-container">
                <Button
                  color="primary"
                  onClick={this.cancel.bind(this)}
                  style={{ marginRight: "20px" }}
                >
                  {this.trans("button-cancel")}
                </Button>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={() => this.setState({ finishPopupOpen: true })}
                  disabled={this.state.isSaving}
                >
                  {this.trans("button-create")}
                </Button>
              </div>
            </div>
          </div>

          <div className="box component-contract-extend">
            <div className="component-wrapper no-margin-top">
              <div className="component">
                <Card className="card">
                  <div style={{ padding: "10px 40px 10px 10px" }}>
                    <form>
                      <div style={{ margin: "-14px 0 -20px 0" }}>
                        <UnitLookup
                          {...this.props}
                          id="unitId"
                          name="unitId"
                          ref="UnitLookup"
                          additionalClasses="unit-lookup-component"
                          className="scroll-to-mainTenantContactId"
                          floatingLabelText={this.trans("dropdown-searchforunit-label")}
                          autoSelectId={this.state.selectedUnit?.id}
                          onSelect={this.selectUnit}
                          onClear={this.clearUnit}
                          fullUnitName={true}
                          forceUpdatePage={true}
                          saveDetailsBeforeRedirect={this.saveDetailsBeforeRedirect}
                          width="100%"
                          containerWidth="60%"
                          error={this.getErrorFor("unitId")}
                        />
                      </div>

                      {
                        this.state.previousContract?.unitId !== this.state.selectedUnit?.id &&
                        this.state.selectedUnit?.defaultChargeTemplates.length > 0 && (
                          <table style={{ margin: "0 0 2px -10px" }}>
                            {
                              this.state.selectedUnit?.defaultChargeTemplates.length > 0 && (
                                <tr>
                                  <td className="align-left first-column">
                                    {`${this.trans("section/defaultunitchargetemplates-unitupdate/settings-title")}:`}
                                  </td>
                                  <td className="align-left">
                                    <div style={{ display: "flex", flexDirection: "column" }}>
                                      {
                                        this.state.selectedUnit?.defaultChargeTemplates.map((chargeTemplate: ChargeTemplateInterface) => {
                                          return (
                                            <div>{`${this.formatter.checkTranslationType(this.trans(chargeTemplate?.type?.label, {}, "", chargeTemplate?.type?.system), chargeTemplate?.type?.label, chargeTemplate?.type?.system)}, ${this.formatter.formatNumber(chargeTemplate?.amount, chargeTemplate?.currency)}`}</div>
                                          );
                                        })
                                      }
                                    </div>
                                  </td>
                                </tr>
                              )
                            }
                          </table>
                        )
                      }

                      <div style={{ margin: "-14px 0" }}>
                        <div style={{ display: "flex", alignItems: "center" }}>
                          <div className="search-bar-container" style={{ width: "270px" }}>
                            <Searchbar
                              {...this.props}
                              name="personId"
                              className="scroll-to-mainTenantContactId"
                              id="selectedTenantForContract"
                              ref="TenantLookup"
                              floatingLabelText={this.trans("label-tenant")}
                              allResults={true}
                              objectField={true}
                              onChange={this.selectTenant}
                              onClear={this.clearTenant}
                              selectedEntity={this.state.selectedTenant}
                              searchParameter={"contactsSearch"}
                              error={this.getErrorFor("mainTenantContactId") || this.getErrorFor("contactForContracts[0].contactId")}
                              searchText={this.state.selectedTenant ? `${this.state.selectedTenant.nameOfEntity}, ${this.state.selectedTenant.displayName}` : null}
                              styleInModal={"pick-object-modal"}
                              createButton={"dropdown-button/newtenant"}
                              openCoachCreateNewEntity={() => {
                                this.setState({
                                  openCoachCreateNewTenant: true,
                                  selectedTenant: null
                                })
                              }
                              }
                            />
                          </div>

                          <TextField
                            className="form-element"
                            style={{ width: "40%", boxSizing: "border-box", marginLeft: "45px" }}
                            type="text"
                            label={this.trans("label-description")}
                            value={this.trans("label-tenant-description")}
                            variant="standard"
                            disabled={true}
                            error={false}
                          />
                        </div>
                      </div>

                      {this.renderAdditionalFields()}

                      {this.state.selectedTenant && (
                        <div style={{ margin: "10px 0 0 0" }}>
                          <Button
                            color="primary"
                            style={{
                              width: "60%",
                              boxSizing: "border-box",
                              border: "1px solid rgba(0,0,0,.1)",
                              display: "inline-block",
                              marginLeft: "0px"
                            }}
                            className="plus-button"
                            onClick={this.addAdditionalFields}
                          >
                            {this.trans("contract-renew-button-add-person-to-contract")}
                          </Button>
                        </div>
                      )}

                      <DatePickerComponent
                        {...this.props}
                        id="firstDate"
                        name="firstDate"
                        className="scroll-to-extensionDate"
                        label={this.trans("first-date")}
                        initialDate={this.state.extensionDate}
                        onChange={date => this.selectDate(date, "extensionDate")}
                        minDate={this.state.previousContract?.firstDate < Time.currentMonthStartMinusYears(1) ?
                          Time.currentMonthStartMinusYears(1) : this.state.previousContract?.firstDate}
                        minDatePlusDays={this.state.previousContract?.firstDate < Time.currentMonthStartMinusYears(1) ? 0 : 1}
                        maxDate={Time.currentDatePlusYears(1)}
                        clearButton={true}
                        width="60%"
                        error={this.getDetailErrorFor("extensionDate")}
                        margin={"10px 0px 0px 0px"}
                      />

                      {/* <div style={{display: "flex", alignItems: "center"}}>
                        <div className="wrapper-for-field" style={{width: "60%"}}>
                          <DatePickerComponent
                            {...this.props}
                            name="lastDate"
                            className="scroll-to-lastDate"
                            label={this.trans("expiration-date") + " 1" + Time.getDatepickerHint() + this.trans("field/optional")}
                            initialDate={this.state.lastDate}
                            onChange={date => this.selectDate(date, "lastDate")}
                            minDate={this.state.extensionDate}
                            minDatePlusDays={1}
                            minDateMessage={this.trans("field/lastfinalenddate-info/error")}
                            hint={this.state.datepickerHint}
                            clearButton={true}
                            error={this.state.datepickerError}
                            margin={"7px 0px 0px 0px"}
                          />
                          <div className={`block-tooltip ${this.state.tooltipOpen ? 'open-tooltip' : 'close-tooltip'}`}  onClick={this.openTooltip}>
                            <div id="tooltip-block" className="tooltip-icon">?</div>
                            <span id="hidden-hint" className="hidden">{this.trans("page/contracts-hint/lastdate-info")}</span>
                          </div>
                        </div>
                        {this.renderNotificationDateQuicksets()}
                      </div>

                      <DatePickerComponent
                        {...this.props}
                        id="finalDate"
                        name="finalDate"
                        className="scroll-to-finalRentalPeriodDate"
                        label={this.trans("expiration-date") + " 2" + Time.getDatepickerHint() + this.trans("field/optional")}
                        initialDate={this.state.finalRentalPeriodDate}
                        onChange={date => this.selectDate(date, "finalRentalPeriodDate")}
                        minDate={this.state.extensionDate}
                        minDatePlusDays={1}
                        minDateMessage={this.trans("field/lastfinalenddate-info/error")}
                        clearButton={true}
                        width="60%"
                        error={this.getErrorFor("finalRentalPeriodDate")}
                        margin={"7px 0px 0px 0px"}
                      /> */}

                      {/* <div style={{ display: "flex", alignItems: "center" }}>
                        <DatePickerComponent
                          {...this.props}
                          id="expirationDate"
                          name="expirationDate"
                          className="scroll-to-expirationDate"
                          label={this.trans("contract-expiration-date") + this.trans("field/optional")}
                          initialDate={this.state.expirationDate}
                          value={this.state.expirationDate}
                          minDate={this.state.extensionDate < new Date() ? new Date() : this.state.extensionDate}
                          minDatePlusDays={0}
                          onChange={date => this.selectDate(date, "expirationDate")}
                          clearButton={true}
                          width="60%"
                          error={this.getErrorFor("expirationDate")}
                          margin={"7px 0px -5px 0px"}
                        />

                      </div>
                      <TextField
                        type="text"
                        className="form-element"
                        value={this.state.rentNotificationText}
                        onChange={(e) => this.setState({ rentNotificationText: e.target.value, hasModifiedData: true })}
                        label={this.trans("dialog-new-notification-text")}
                        style={{ width: "60%" }}
                      /> */}
                      <div style={{ width: "60%" }}>
                        <TextField
                          autoComplete="off"
                          id="note"
                          name="note"
                          className="form-element full-size scroll-to-note"
                          type="text"
                          multiline={true}
                          rowsMax={10}
                          label={this.trans("note") + this.trans("field/optional")}
                          value={this.state.note}
                          onChange={this.sync.bind(this, this.syncronizers.EVENT, "note")}
                          variant="standard"
                          error={!!this.getErrorFor("note")}
                          helperText={this.getErrorFor("note")}
                        />
                      </div>

                      <div style={{ marginTop: "-10px" }}>
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={this.state.isCommercial}
                              onChange={this.changeIsCommercial}
                              color="primary"
                            />
                          }
                          label={this.trans("page/contracts-label/iscommercialcontract", { vatPercentage: this.props?.app?.settings?.agency?.vatPercentage })}
                        />
                      </div>

                      <div style={{ paddingBottom: "20px" }}>
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={this.state.autoSendInvoiceToTenant}
                              onChange={this.changeAutoSendInvoiceToTenant}
                              color="primary"
                            />
                          }
                          label={this.trans("page/contracts-label/automaticallysendrentinvoice")}
                        />
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={this.state.isPaidDirectlyToOwner}
                              onChange={this.switchIsPaidDirectlyToOwner}
                              color="primary"
                            />
                          }
                          label={this.trans("coach/newcontract-step/paiddirectlytoowner-label")}
                        />
                      </div>
                    </form>
                  </div>
                </Card>
              </div>
            </div>

            <div className="component-wrapper no-shadow">
              <Card className="card no-padding">
                <div className="label-container no-border" style={{ backgroundColor: "#f9f9f9", height: "59px" }}>
                  <Button
                    color="primary"
                    variant="outlined"
                    onClick={this.openChargeTemplateCreatePopup}
                    style={{
                      margin: "0 40px 0 0",
                      padding: "0 10px",
                      height: "50px"
                    }}
                  >
                    {this.trans("dialog/newcontractitems-title")}
                  </Button>
                </div>
                <div>
                  <div
                    style={{
                      padding: "10px 12px 10px 10px",
                      marginBottom: "10px"
                    }}
                  >
                    {
                      !!monthlyChargeTemplatesAmount ?
                        Translator.transJSX("pages/contract-section/price-info/totalmonthlyamount", { amount: <span style={{ fontWeight: "bold" }}>{this.formatter.formatNumber(monthlyChargeTemplatesAmount * 100, this.state.chargeTemplates[0] && CurrencyContainer.pickFromId(this.state.chargeTemplates[0].currency))}</span> }) :
                        Translator.transJSX("pages/contract-section/price-info/totalmonthlyamount", { amount: <span style={{ fontWeight: "bold" }}>{this.formatter.formatNumber(monthlyChargeTemplatesAmount, this.props.app.settings.user.currency)}</span> })
                    }
                  </div>
                  <div>
                    {
                      this.state.chargeTemplates
                        .map((chargeTemplate: ChargeTemplateInterface, index: number) => {
                          return (
                            <div className="component-wrapper no-margins has-margin-bottom">
                              <div className="component">
                                <ChargeTemplateCard
                                  key={`chargeTemplate-${chargeTemplate?.id}`}
                                  chargeTemplate={chargeTemplate}
                                  openChargeTemplate={() => this.setState({ selectedChargeTemplate: chargeTemplate, selectedChargeIndex: index }, () => this.openChargeTemplateUpdatePopup(this.state.selectedChargeTemplate, this.state.selectedChargeIndex))}
                                  removeChargeTemplate={() => this.setState({ selectedChargeTemplate: chargeTemplate, selectedChargeIndex: index }, () => this.deleteChargeTemplate())}
                                />
                              </div>
                            </div>
                          );
                        })
                    }
                  </div>
                </div>
              </Card>
            </div>

            <div className="component-wrapper">
              <Attachment
                {...this.props}
                typeOfComponent="shared"
                title={this.trans("attachments-for-contract")}
                relation="contractId"
                onAmazonFolderNameGeneration={!this.state.amazonFolderName ?
                  this.sync.bind(this, this.syncronizers.VALUE, "amazonFolderName") : null}
                amazonFolderName={!!this.state.amazonFolderName ? this.state.amazonFolderName : null}
                attachments={this.state.attachments}
                updateParentState={attachments => this.setState({ attachments: attachments })}
                onChangeAvatar={avatar => (this.refs.EntityAvatar as any) && (this.refs.EntityAvatar as any).change(avatar)}
                onLastImageDeleted={() => (this.refs.EntityAvatar as any) && (this.refs.EntityAvatar as any).revert()}
              />
            </div>
          </div>
        </div>

        <LeavePromptDialog
          {...this.props}
          prioritizeClosing={true}
          onClose={() => this.setState({ openLeavePrompt: false, nextPath: "" })}
          openLeavePrompt={this.state.openLeavePrompt}
          onDiscard={this.leave.bind(this)}
          onSave={() => { this.setState({ openLeavePrompt: false, finishPopupOpen: true }); }}
          hideCross={true}
          leavePrompt={true}
        />

        <PromptDialog
          {...this.props}
          title={this.trans("renew-contract")}
          content={(
            <div>
              <p>{this.trans("dialog/preprocess-renewcontract")}</p>
              <DatePickerComponent
                {...this.props}
                id="firstDate"
                name="firstDate"
                className="scroll-to-extensionDate"
                label={this.trans("first-date")}
                initialDate={this.state.extensionDate}
                onChange={date => this.selectDate(date, "extensionDate")}
                minDate={this.state.previousContract?.firstDate < Time.currentMonthStartMinusYears(1) ?
                  Time.currentMonthStartMinusYears(1) : this.state.previousContract?.firstDate}
                minDatePlusDays={this.state.previousContract?.firstDate < Time.currentMonthStartMinusYears(1) ? 0 : 1}
                maxDate={Time.currentDatePlusYears(1)}
                clearButton={true}
                width="60%"
                error={this.getErrorFor("extensionDate")}
              />
            </div>
          )}
          negativeButtonLabel={this.trans("dialog/renewcontract-button/cancel")}
          positiveButtonLabel={this.trans("dialog/renewcontract-button/continue")}
          openLeavePrompt={this.state.renewStartPopup}
          prioritizeClosing={true}
          onSave={() => {
            this.setState({ renewStartPopup: false });
          }}
          onDiscard={() => {
            this.setState({ renewStartPopup: false }, this.selectDate(Time.firstDateNextMonth(), "extensionDate"));
          }}
        />

        <PromptDialog
          {...this.props}
          title={this.trans("renew-contract")}
          content={(
            <div>
              <p>{this.trans("click-finish-to-create-new-contract")}</p>
              {/* <p>{"Click "Concept" if you first need to present a copy to the tenant for signing. Click Cancel to verify the details of the new contract registration one more time."}</p> */}
            </div>
          )}
          negativeButtonLabel={this.trans("button-cancel")}
          positiveButtonLabel={this.trans("button-finish")}
          openLeavePrompt={this.state.finishPopupOpen}
          prioritizeClosing={true}
          onDiscard={() => {
            this.setState({ finishPopupOpen: false });
          }}
          onSave={() => {
            this.setState({ finishPopupOpen: false }, this.save);
          }}
        />

        <PromptDialog
          {...this.props}
          title={this.trans("page/renewcontract-dialog/calculateprice-title")}
          content={(
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start" }}>
              <div className="form-element full-size no-margins">
                <TextField
                  autoComplete="off"
                  className="form-element full-size"
                  type="text"
                  label={this.trans("page/renewcontract-dialog/calculateprice-field/oldamount-label")}
                  value={this.state.priceOldAmount}
                  disabled={true}
                  variant="standard"
                  error={false}
                />
              </div>

              <div className="form-element full-size no-margins margin-sides-20">
                <TextField
                  autoComplete="off"
                  className="form-element full-size"
                  type="text"
                  label={this.trans("page/renewcontract-dialog/calculateprice-field/percentage-label")}
                  onChange={this.changePricePercentage}
                  value={this.state.pricePercentage}
                  variant="standard"
                  error={false}
                />
              </div>

              <div className="form-element full-size no-margins">
                <TextField
                  autoComplete="off"
                  className="form-element full-size scroll-to-amount"
                  type="text"
                  label={this.trans("page/renewcontract-dialog/calculateprice-field/newamount-label")}
                  value={this.state.priceNewAmount}
                  onChange={this.changePriceNewAmount}
                  autoFocus={true}
                  variant="standard"
                  error={!!this.getErrorFor("amount")}
                />
                {!!this.getErrorFor("amount") && <div className="component-error-text">{this.getErrorFor("amount")}</div>}
              </div>
            </div>
          )}
          negativeButtonLabel={this.trans("button-cancel")}
          positiveButtonLabel={this.trans("button-save")}
          openLeavePrompt={this.state.isCalculatePricePopupOpen}
          prioritizeClosing={true}
          onDiscard={() => {
            this.setState({ isCalculatePricePopupOpen: false, pricePercentage: "0" });
          }}
          onSave={() => {
            const chargeTemplate = {
              ...this.state.selectedChargeTemplate,
              amount: parseFloat(parseFloat(String(Formatter.deleteExtraSpace(this.state.priceNewAmount)).replace(",", ".")).toFixed(2)),
              oldAmount: Number(this.state.priceOldAmount)
            };

            this.updateChargeTemplate(chargeTemplate);
          }}
        />

        <CoachNewTenantDialog
          {...this.props}
          openCoachCreateNewTenant={this.state.openCoachCreateNewTenant}
          existingTenant={this.state.selectedTenant instanceof Company ? this.state.selectedTenant : null}
          onCloseTenantCoach={entity => {
            if (entity) {
              this.setState({
                openCoachCreateNewTenant: false
              }, () => this.selectTenant(entity, true))
            } else {
              this.setState({
                openCoachCreateNewTenant: false
              })
            }
          }}
        />

        <DeleteEntityPrompt
          {...this.props}
          entityName={'agency-fee-remove-from-settings-page'}
          isOpen={this.state.isAgencyRemoveDialog}
          onCancel={this.closePrompt}
          onDelete={this.deleteAgencyFee}
        />

        <PromptDialog
          {...this.props}
          title={this.state.newChargeTemplatePopupOpen ? this.trans("dialog/newcontractitems-title") : this.trans("dialog/contractitemdetails-title")}
          content={this.getChargeTemplatePopupContent()}
          openLeavePrompt={this.state.isChargeTemplatePopupOpen}
          onClose={this.closeChargeTemplatePopup}
          onlyPositiveButton={false}
          prioritizeClosing={true}
          withoutDefaultDilaogButtons={true}
        />

        <PageTransition isSaving={this.state.isSaving} />
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    app: state.app,
    units: state.units,
    component: state.contractExtend,
    chargeTemplateCreate: state.chargeTemplateCreate,
    chargeTemplateUpdate: state.chargeTemplateUpdate,
    globalTypes: state.globalTypes,
    agencyFeeCreate: state.agencyFeeCreate,
    agencyFeeUpdate: state.agencyFeeUpdate
  };
};

export default connect(mapStateToProps)(
  ContractExtend
);
